export default {
  myWork_no_homework: '還沒有作業',
  myWork_homework_list: '0407Web-显示我的作业列表',
}
